import { render } from "./login-header.vue?vue&type=template&id=032d2db2"
import script from "./login-header.vue?vue&type=script&lang=js"
export * from "./login-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__